import { Pipe, inject, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({ name: 'formatNumber' })
export class FormatNumberPipe implements PipeTransform {
  private decimalPipe = inject(DecimalPipe);

  transform(value: string | number, digitsInfo = ''): string | null {
    return this.decimalPipe.transform(value, digitsInfo, 'de-AT');
  }
}
